import React, { useEffect, useMemo, useState } from 'react'
import { Card, Container, Input, Label } from 'reactstrap'
import { showAlert } from '../../../utils/alert';
import { Breadcrumbs, Btn } from '../../../AbstractElements'
import SeachBar from '../../UiKits/SearchBar'
import { addCategories, deleteCatgory, editCatgory, fetchCategories } from '../../../firebase/utils'
import { Table } from 'antd'
import QuizCategory from './QuizCategory'
import CommonModal from '../../UiKits/Modals/common/modal'
import { quizUpdateValidateData } from '../../../utils/validate'
import { toast } from 'react-toastify'
import { searchInArray } from '../../../utils/search';

const Quizzes = () => {
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const [show, setShow] = useState({
    edit: false,
    create: false,
    data: null
  })

  const fetchData = async () => {
    const data = await fetchCategories()
    setData(data)
    setLoading(false)
  }

  const filteredQuizesData = useMemo(() => {
    const keys = ['quizModule', 'quizName']
    const FilteredData = searchInArray(data, keys, search)
    return FilteredData
  }, [search, data])

  const updateCategory = async () => {
    if (quizUpdateValidateData(show.data)) {
      if (show.create) {
        const quiz = await addCategories(show.data.quizName, show.data.quizModule)
        const newCategory = {
          id: quiz.id,
          key: quiz.id,
          quizName: show.data.quizName,
          quizModule: show.data.quizModule
        }
        const categories = [...data]
        categories.push(newCategory)
        console.log(categories)
        setData(categories)
        toast.success('Category Added Sucessfully')
        setShow({
          ...show,
          create: false,
          data: null
        })

      } else {
        const data = {
          name: show.data.quizName,
          module: show.data.quizModule
        }
        await editCatgory(show.data.id, data)
        setData(prevState => prevState.map(obj =>
          obj.id === show.data.id ? { ...obj, quizName: show.data.quizName, quizModule: show.data.quizModule } : obj
        ))
        toast.success('Category Updated Sucessfully')
        setShow({
          ...show,
          edit: false,
          data: null
        })
      }
    } else {
      toast.error('Please enter all the fields')
    }
  }

  const deleteCategory = async (quiz) => {
    const warningText = `Are you sure you want to delete 
    ${quiz.quizName} category?`
    const isConfirm = await showAlert(warningText, 'Delete')
    if (isConfirm) {
      await deleteCatgory(quiz.id)
      setData(data.filter((qui) => qui.id !== quiz.id))
      toast.success('Quiz Deleted Successfully')
    }
  }

  const onChangeHandler = (e) => {
    setShow({
      ...show,
      data: {
        ...show.data,
        [e.target.name]: e.target.value
      }
    })
  }

  const tableColumns = [
    {
      title: "Quiz Category",
      dataIndex: "quizName",
      sorter: (a, b) => {
        const valueA = a.quizName;
        const valueB = b.quizName;
        return valueA.localeCompare(valueB)
      }
    },
    {
      title: "Quiz Module",
      dataIndex: "quizModule",
      sorter: (a, b) => {
        const valueA = a.quizModule;
        const valueB = b.quizModule;
        return valueA.localeCompare(valueB)
      }
    },
    {
      title: "Edit",
      render: (e) => <div className='d-flex align-items-center justify-content-center'><Btn attrBtn={{ color: "primary", onClick: () => setShow({ ...show, edit: true, data: e }) }}>Edit</Btn></div>
    },
    {
      title: "Delete",
      render: (e) => <div className='d-flex align-items-center justify-content-center'><Btn attrBtn={{ color: "primary", onClick: () => deleteCategory(e) }}>Delete</Btn></div>

    },
  ]

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <>
      <Breadcrumbs mainTitle={'Quizzes'} />
      <Container fluid={true} className="dashboard-default">
        <Card className='p-3'>
          <div className='bug-report-search d-flex align-items-center'>
            <SeachBar search={search} setSearch={setSearch} loading={loading}/>
            <Btn attrBtn={{
              color: 'primary',
              className: 'm-l-10',
              onClick: () => setShow({
                ...show,
                create: true,
                data: {}
              }),
              disabled: loading,
            }}>Add</Btn>
          </div>
          <div className='ant-design-table'>
            <Table
              loading={loading}
              columns={tableColumns}
              dataSource={filteredQuizesData}
              pagination={false}
              bordered={true}
              expandable={{
                expandedRowRender: (record) => (
                  <QuizCategory record={record} setData={setData} data={data} />
                ),

              }}

              scroll={{ x: 'auto' }}
            />
          </div>
        </Card>
        {(show.edit || show.create) && <CommonModal
          isOpen={show.edit || show.create}
          toggler={() => {
            setShow({
              ...show,
              create: false,
              edit: false,
            })
          }}
          successText='Done'
          title={show.create ? 'Create Category' : 'Edit Category'}
          success={updateCategory}
        >
          <div>
            <div>
              <Label
                htmlFor='quizName'
                className='f-w-500'
              >
                Quiz Name
              </Label>
              <Input
                id='quizName'
                name='quizName'
                value={show.data.quizName}
                onChange={onChangeHandler}
              />
            </div>
            <div className='m-t-10'>
              <Label
                htmlFor='quizModule'
                className='f-w-500'
              >
                Quiz Module
              </Label>
              <Input
                id='quizModule'
                name='quizModule'
                value={show.data.quizModule}
                onChange={onChangeHandler}
              />
            </div>
          </div>
        </CommonModal>}
      </Container>
    </>
  )
}

export default Quizzes